import React from "react";
import { useI18n } from "@core/i18n/i18n";
import NoProgramsIcon from "@assets/icons/no-programs.svg";
import { useNavigate } from "@core/routing/use-navigate";
import { MessageContainer } from "@ui/components/common/message-container";
import { RoutesPath } from "@ui/navigation/routes";
import { AnalyticsProgramLocation, sendAnalyticsEventCreateProgram } from "@domain/program/program-analytics";

interface EmptyProgramsProps {
	onSecondaryClick: () => void;
}

export const EmptyPrograms: React.FC<EmptyProgramsProps> = ({ onSecondaryClick }) => {
	const { format } = useI18n();
	const navigate = useNavigate();
	const sendAnalytics = () => sendAnalyticsEventCreateProgram(AnalyticsProgramLocation.PROGRAM_PAGE);

	return (
		<MessageContainer
			style={{ flexGrow: 1, padding: "72px 32px" }}
			iconSvg={NoProgramsIcon}
			title={format("templateListing.noPrograms.title")}
			description={format("templateListing.noPrograms.description")}
			cta={{
				label: format("templateListing.createProgramButton"),
				onClick: () => {
					sendAnalytics();
					navigate(RoutesPath.TemplateBuilder);
				},
			}}
			secondaryCta={{
				label: format("templateListing.viewTemplatesButton"),
				onClick: onSecondaryClick,
			}}
		/>
	);
};
